const Footer = () => {
    return (
        <div
            style={{
                textAlign: "center",
                marginBottom: 10,
            }}
        >
            Made with ♥ by{" "}
            <a
                href="https://keshavgupta848101.github.io/PersonalPortfolio/"
                style={{ cursor: "pointer" }}
            >
                Keshav
            </a>
        </div>
    );
};

export default Footer;